import { Box, styled } from '@mui/material';

export const SectionContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'componentOrder' && prop !== 'noSidePadding',
})(({ theme, componentOrder, noSidePadding }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: noSidePadding ? '16px 0 24px' : '16px 16px 24px',
  order: componentOrder,

  '&:not(:last-of-type)': {
    borderBottom: `1px solid ${theme.palette.colors.dashboardDivider}`,
  },

  [theme.breakpoints.up('sm')]: {
    padding: noSidePadding ? '16px 0 24px' : '16px 32px 24px',
  },
  [theme.breakpoints.up('md')]: {
    padding: noSidePadding ? '16px 0 24px' : '16px 48px 24px',
  },
}));

export const HeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'extraSidePadding',
})(({ theme, extraSidePadding }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: '8px',
  padding: extraSidePadding ? '0 32px' : '0 16px',

  [theme.breakpoints.up('sm')]: {
    padding: extraSidePadding ? '0 52px' : '0 20px',
  },
  [theme.breakpoints.up('md')]: {
    padding: extraSidePadding ? '0 72px' : '0 24px',
  },
}));
